import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const setInterceptors = (axios: AxiosInstance) => {
  axios.interceptors.request.use(
    (request: any) => {
      request.headers['language'] = localStorage.getItem('i18nextLng');
      return request;
    },
    (req) => req
  );
};

export const generateBaseAxiosClient = (config: AxiosRequestConfig) => {
  const instance = axios.create({ ...config, withCredentials: true });
  // setInterceptors(instance);

  axios.interceptors.request.use(
    (request: any) => {
      request.headers['language'] = localStorage.getItem('i18nextLng');
      return request;
    },
    (req) => req
  );
  return instance;
};
